/**
 * Samenwerkingspartner (SWP) Constants
 * The SWP is a single placeholder employee used to assign collaboration partners to projects.
 */

export const SWP_EMPLOYEE_ID = 'SWP_PLACEHOLDER'

export const isSWP = employee =>
  employee?.simplicate_id === SWP_EMPLOYEE_ID ||
  employee?.employee_simplicate_id === SWP_EMPLOYEE_ID
